<div *ngIf="!isEdit && clickToEdit" class="display-area" (click)="handleEdit()">
    <div *ngIf="editorId === 'task_description' && !displayValue ; else showValue">
        <span class="empty-content">Add a description ...</span>
    </div>
    <ng-template #showValue>
        <quill-view class="remove-padding-quill" [content]="displayValue" [sanitize]="true" format="html"></quill-view>
    </ng-template>
</div>

<ng-container *ngIf="isEdit || !clickToEdit">
    <quill-editor class="ql-editor" [(ngModel)]="editorValue"
                  [modules]="quillModules"
                  [styles]="editorStyles"
                  [id]="editorId"
                  [bounds]="'#' + editorId"
                  (onContentChanged)="onContentChanged($event)"
                  (onEditorCreated)="onEditorCreated($event)"
                  #editor
                  ></quill-editor>

    <div class="action-group" *ngIf="showAction">
        <button nz-button nzType="primary" class="action-item" (click)="handleSave()"
                [nzLoading]="saveLoading || uploadingImageCount !== 0">Save</button>
        <button nz-button nzDanger class="action-item" (click)="cancelEdit()">Cancel</button>
    </div>
</ng-container>
